import { render } from "./pending-variances.vue?vue&type=template&id=17a0c71b"
import script from "./pending-variances.vue?vue&type=script&lang=js"
export * from "./pending-variances.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__